import { render } from "./MainActions.vue?vue&type=template&id=4882b91e&scoped=true"
import script from "./MainActions.vue?vue&type=script&lang=js"
export * from "./MainActions.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftDetailsMainActions.scss?vue&type=style&index=0&id=4882b91e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4882b91e"]])

export default __exports__